import { render, staticRenderFns } from "./customAgent.vue?vue&type=template&id=22d9eeb3&scoped=true&"
import script from "./customAgent.vue?vue&type=script&lang=js&"
export * from "./customAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d9eeb3",
  null
  
)

export default component.exports